<template>
  <div class="asset_detail">
    <a-descriptions bordered size="small" title="资产基本信息">
      <a-descriptions-item label="资产描述" :span="2">{{ detail.txt50 }}</a-descriptions-item>
      <a-descriptions-item label="资产编码">{{ detail.anln1 }}</a-descriptions-item>
      <a-descriptions-item label="资产分类">{{ detail.txk20 }}</a-descriptions-item>
      <a-descriptions-item label="资产数量">{{ detail.menge }}</a-descriptions-item>
      <a-descriptions-item label="资产使用年限">{{ detail.ndjar }}</a-descriptions-item>
      <a-descriptions-item label="资本化日期">{{ detail.aktiv }}</a-descriptions-item>
      <a-descriptions-item label="首次购置日期">{{ detail.zugdt }}</a-descriptions-item>
      <a-descriptions-item label="不活动日期">{{ detail.deakt }}</a-descriptions-item>
      <a-descriptions-item label="设备号">{{ detail.sernr }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" title="资产状态信息">
      <a-descriptions-item label="使用状况">{{ detail.ordtx41 }}</a-descriptions-item>
      <a-descriptions-item label="增加方式">{{ detail.ordtx42 }}</a-descriptions-item>
      <a-descriptions-item label="资产状态">{{ detail.gdlgrpTxt }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" title="资本组织信息">
      <a-descriptions-item label="所属公司">{{ detail.butxt }}</a-descriptions-item>
      <a-descriptions-item label="所属成本中心" :span="2">{{ detail.ktext }}</a-descriptions-item>
      <a-descriptions-item label="归口管理部门" :span="3">{{ detail.ordtx }}</a-descriptions-item>
      <a-descriptions-item label="使用部门">{{ detail.sapshort }}</a-descriptions-item>
      <a-descriptions-item label="责任人" :span="2">{{ detail.raumn }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" title="资本来源信息">
      <a-descriptions-item label="供应商编号">{{ detail.lifnr }}</a-descriptions-item>
      <a-descriptions-item label="供应商名称" :span="2">{{ detail.lifnrName }}</a-descriptions-item>
      <a-descriptions-item label="制造商编号">{{ detail.x3 }}</a-descriptions-item>
      <a-descriptions-item label="制造商名称" :span="2">{{ detail.herst }}</a-descriptions-item>
      <a-descriptions-item label="在建资产编号">{{ detail.anln1 }}</a-descriptions-item>
      <a-descriptions-item label="在建资产名称" :span="2">{{ detail.txa50 }}</a-descriptions-item>
      <a-descriptions-item label="合同编号">{{ detail.wbhth }}</a-descriptions-item>
      <a-descriptions-item label="关联采购订单" :span="2">{{ detail.ebeln }}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { getAssetDetail } from '@/api/assetLedger'
import moment from 'moment'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initDetail()
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {}
    }
  },
  methods: {
    // 获取资产详情
    initDetail () {
      const { model } = this
      const params = {
        anln1: model.anln1,
        bukrs: model.bukrs,
        anln2: model.anln2
      }
      getAssetDetail(params).then(res => {
        if (res.status === 0) {
          res.data.aktiv = res.data.aktiv ? moment(res.data.aktiv).format('YYYY-MM-DD') : ''
          res.data.zugdt = res.data.zugdt ? moment(res.data.zugdt).format('YYYY-MM-DD') : ''
          res.data.deakt = res.data.deakt ? moment(res.data.deakt).format('YYYY-MM-DD') : ''
          this.detail = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.asset_detail{
  margin-left: -1px;
  margin-right: -1px;
  /deep/.ant-descriptions{
    margin-bottom: -1px;
    .ant-descriptions-title{
      margin-bottom: 0;
      line-height: 32px;
      font-size: 12px;
      color: #08409F;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      padding: 0 12px;
      //border-right: 1px solid #DDDDDD;
      // 线颜色修改
      border-right: 1px solid #DDDDDD;
      background: #F5F5F5;
    }
    .ant-descriptions-view{
      border-radius: 0;
      width: 100%;
      //border-color: #DDDDDD;
      // 线颜色修改
      border-color: #DDDDDD;
      border-left: none;
      border-right: none;
      .ant-descriptions-row{
        border-bottom: none;
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          padding: 8px 12px;
          height: 40px;
          //border-bottom: 1px solid #DDDDDD;
          //border-color: #DDDDDD;
          // 线颜色修改
          border-bottom: 1px solid #DDDDDD;
          border-color: #DDDDDD;
        }
        .ant-descriptions-item-label{
          background: #E7F4FF;
          width: calc(100% / 9);
        }
        .ant-descriptions-item-content[colspan="1"]{
          // width: 230px;
          width: calc(100% / 9 * 2);
        }
        .ant-descriptions-item-content[colspan="3"]{
          // width: 580px;
          width: calc(100% / 9 * 5);
        }
        .ant-descriptions-item-content[colspan="5"]{
          // width: 930px;
          width: calc(100% / 9 * 8);
        }
      }
      .ant-descriptions-row:last-child{
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          // border-bottom: none;
        }
      }

    }
  }
  /deep/.ant-descriptions:last-child{
    .ant-descriptions-view{
      border-bottom: none;
    }
  }
}
</style>